import { FC } from 'react'
import fieldManifest from '../../fieldManifest'
import { TypeBadgeWrapper } from './styled'

const TYPE_LIST = ['Logon', 'HeartBeat', 'NewOrderSingle', 'ER FILL', 'Reject']
const PALETTE: {
    [key: string]: string
} = {
    HeartBeat: '',
    NewOrderSingle: '#17A500',
    'ER FILL': 'cornflowerblue',
    Reject: '#C44E9A',
    MsgType: '#17A500',
    EncryptMethod: '',
    HeartBtInt: '',
    BUY: '#00A79D',
    MSFT: '#E29633',
    ORCL: '',
    SPY: ''
}

const COMMON_TAGS_LIST = [
    'Login',
    'Heartbeat',
    'Logout',
    'ResendRequest',
    'SequenceReset',
    'TestRequest',
    'BeginString',
    'BodyLength',
    'SenderCompID',
    'TargetCompID',
    'OnBehalfOfCompID',
    'DeliverToCompID',
    'SecureDataLen',
    'SecureData',
    'MsgSeqNum',
    'SenderSubID',
    'SenderLocationID',
    'TargetSubID',
    'TargetLocationID',
    'OnBehalfOfSubID',
    'OnBehalfOfLocationID',
    'DeliverToSubID',
    'DeliverToLocationID',
    'PossDupFlag',
    'PossResend',
    'SendingTime',
    'OrigSendingTime',
    'XmlDataLen',
    'XmlData',
    'MessageEncoding',
    'LastMsgSeqNumProcessed',
    'HopCompID',
    'HopSendingTime',
    'HopRefID'
]

const UNCOMMON_TAGS_LIST = ['MsgType', 'EncryptMethod', 'HeartBtInt']

const SMALL_TYPE_LIST = ['BUY', 'SELL', 'MSFT', 'ORCL', 'SPY']

const allTypeList = [...TYPE_LIST, ...COMMON_TAGS_LIST, ...UNCOMMON_TAGS_LIST, ...SMALL_TYPE_LIST]

const getBadgeBgColor = (type: string, isDetails?: boolean) => {
    if (COMMON_TAGS_LIST.includes(type)) {
        return '#498DE4'
    }
    if (!fieldManifest[type] && isDetails) {
        return '#666666'
    }
    return PALETTE[type] || '#8275E1'
}

interface ITypeBadgeProps {
    type: typeof allTypeList[number];
    isDetails?: boolean;
}

export const TypeBadge: FC<ITypeBadgeProps> = ({ type, isDetails }) => {
    return (
        <TypeBadgeWrapper small={SMALL_TYPE_LIST.includes(type)} bgColor={getBadgeBgColor(type, isDetails)}>
            {type}
        </TypeBadgeWrapper>
    )
}
